<template>
  <div id="admin-work-license-list">
    <!-- 上岗证考核列表 -->
    <diy_table
      :loading="loading"
      :tipData="tipData"
      :active="active"
      :searchData="searchData"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :tableState="true"
      :pageData="pageData"
      @handleClickTop="handleClickTop"
      @showActive="showActive"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>
  </div>
</template>

<script>
import * as workLicenseData from "./js/work_license.js";
import * as base from "../js/base.js";
export default {
  data() {
    return {
      tipData: [
        { text: "全部", key: "-1" },
        { text: "待发布", key: "0" },
        { text: "已归档", key: "2" },
      ],
      loading: false,
      active: "-1",
      searchData: this.$systemBaseData.getSearchData("workLicense"),
      buttonList: this.$systemBaseData.getTopButArray("workLicense"),
      tableMenu: this.$systemBaseData.getTableMenuData("workLicense"),
      tableData: [],
      tableButton: this.$systemBaseData.getTableButtonList("workLicense", ""),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempTask: {}, // 临时任务
      options: {
        professional: [],
      },

      allAuthorityList: [],
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  考试管理 32
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "32" },
        });
        this.buttonList = base.returnAllButton(
          this.buttonList,
          resultData,
          "name"
        );
        this.allAuthorityList = resultData;
      } catch (error) {}
    },
    /**
     * 获取专业下拉框数据
     */
    async getProfessionalList() {
      try {
        let resultData = await this.$request({
          url: "/professional/getProfessionalList",
          method: "post",
          data: { name: "" },
        });
        this.options.professional = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.professional.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取界面数据
     */
    async initTable(data) {
      try {
        this.loading = true;
        setTimeout(async () => {
          let requestData = {
            status: this.active == "-1" ? "" : this.active,
            currentPage: data.pageData.currentPage,
            pageSize: data.pageData.pageSize,
          };
          requestData = this.$baseData.array2json(data.searchData, requestData);
          let resultData = await this.$request({
            url: "/workLicense/getAllWorkLicenseList",
            method: "post",
            data: requestData,
          });
          resultData.tableData.forEach((element) => {
            let buttList = this.$systemBaseData.getTableButtonList(
              "workLicense",
              element.status
            );
            buttList = base.returnAllButton(
              buttList,
              this.allAuthorityList,
              "text"
            );
            this.$set(element, "butList", buttList);
          });
          this.tableData = resultData.tableData;
          this.pageData.total = resultData.total;
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 搜索框边的按钮操作
     */
    handleClickTop(active) {
      switch (active) {
        case "create":
          // 新建上岗证任务
          this.$router.push({
            path: "/admin/work-license-index/edit",
            query: {
              id: "",
            },
          });
          break;

        default:
          break;
      }
    },
    /**
     * 表格中的操作事件
     */
    async handleClick(data) {
      try {
        let resultData = {};
        this.tempTask = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "issue":
            // 发布
            resultData = await this.$request({
              url: "/workLicense/publishWorkLicense",
              method: "post",
              data: { id: this.tempTask.id },
            });
            this.$message.success("发布成功!");
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "unissue":
            // 取消发布
            resultData = await this.$request({
              url: "/workLicense/unpublishWorkLicense",
              method: "post",
              data: { id: this.tempTask.id },
            });
            this.$message.success("取消成功!");
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "edit":
            // 编辑
            this.$router.push({
              path: "/admin/work-license-index/edit",
              query: {
                id: this.tempTask.id,
              },
            });
            break;
          case "show":
            // 查看本次考核的具体信息
            this.$router.push({
              path: "/admin/work-license-index/user-list",
              query: {
                id: this.tempTask.id,
                status: this.tempTask.status,
              },
            });
            break;
          case "end":
            // 归档
            this.$confirm(
              "考核归档后,该任务已全部结束,请确保所有学员的考核成绩已录入",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                resultData = await this.$request({
                  url: "/workLicense/endWork",
                  method: "post",
                  data: { id: this.tempTask.id },
                });
                this.$message.success("考核已归档!");
                await this.initTable({
                  pageData: this.pageData,
                  searchData: this.searchData,
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消归档",
                });
              });

            break;
          case "delete":
            // 删除
            this.$confirm("此操作将永久删除该考核, 是否继续", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                resultData = await this.$request({
                  url: "/workLicense/deleteWorkLicense",
                  method: "post",
                  data: { id: this.tempTask.id },
                });
                this.$message.success("考核已归档!");
                await this.initTable({
                  pageData: this.pageData,
                  searchData: this.searchData,
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消归档",
                });
              });
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * active的监听事件
     */
    showActive(data) {
      this.active = data;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.getProfessionalList();
    this.searchData.forEach((element) => {
      if (element.type == "select") {
        element.options = this.options[element.key];
      }
    });
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
  },
};
</script>

<style lang="less" scoped>
#admin-work-license-list {
  width: 100%;
  height: 100%;
}
</style>